import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import logo from "../../assets/images/Logo.png";
import { useDispatch } from "react-redux";
import { resetAllState } from "../../redux/slice/rootSlice";
import "./Header.css";
import { useLocation } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { Routers } from "../../routes/Constant";
import defaultUserPic from "../../assets/images/default-image.png";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import { message } from "antd";
import { logoutLearner } from "../../redux/slice/authSlice";
import { useSelector } from "react-redux";
import { HashLink } from "react-router-hash-link";

export const Header = ({ update, dynamicRoutes }) => {
  const currentUrl = window.location.href;
  const containsCorporateSiteone = currentUrl.includes("corporate-site-one");
  const containsCorporateSitetwo = currentUrl.includes("corporate-site-two");
  const dispatch = useDispatch();
  const [hamShow, setHamShow] = useState(false);
  const [stickyClass, setStickyClass] = useState("relative");
  const location = useLocation();
  const pathname = useLocation().pathname;
  const navigate = useNavigate();
  const [loggedIn, setLoggedIn] = useState(false);
  const [userImage, setUserImage] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const token = localStorage.getItem("token");
  const [userName, setUserName] = useState("");
  const { learnerDashboardProfileInfo } = useSelector((state) => state?.auth);
  const { learnerDashboardProfileUpdate } = useSelector((state) => state?.auth);
  const stickNavbar = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      if (windowHeight > 100 && location.pathname === "/") {
        setStickyClass("sticky-nav");
      } else {
        setStickyClass("position-relative");
      }
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    setHamShow(false);
  }, [navigate]);

  useEffect(() => {
    window.addEventListener("scroll", stickNavbar);
    return () => {
      window.removeEventListener("scroll", stickNavbar);
    };
  });

  useEffect(() => {
    if (learnerDashboardProfileInfo) {
      setUserName(learnerDashboardProfileInfo.data.name.split(" ")[0]);
      setUserImage(learnerDashboardProfileInfo.data.profile_image);
    }
  }, [learnerDashboardProfileInfo]);

  const logoutHandler = () => {
    dispatch(resetAllState());
    localStorage.clear();
    dispatch(logoutLearner(token));
    localStorage.removeItem("persist:root");
    setShowDropdown(!showDropdown);
    message.success({
      content: "You Logout Successfully",
      duration: 2,
    });
  };
  // Assuming dynamicRoutes is your array of routes
  const uniqueHomeRoutes = Array.from(
    new Set(
      dynamicRoutes
        ?.filter(
          (route) => route.page_type === "home" || route.page_type === "header"
        ) // Corrected condition
        .map((route) => route.pagename) // Map to pagename
    )
  ).map((pagename) =>
    dynamicRoutes.find((route) => route.pagename === pagename)
  ); // Get unique routes

  return (
    <header>
      {containsCorporateSitetwo ? (
        <nav className={`keyzi_navbar--wrapper-white ${stickyClass}`}>
          <Container>
            <div className="keyzi_navbar--inner">
              <div className="keyzi_logo--link">
                <h1>
                  <Link to={Routers.Home}>keyzi</Link>
                </h1>
              </div>
              <div
                className={`${
                  containsCorporateSiteone
                    ? "keyzi_navList--listCsTwo"
                    : "keyzi_navLink--list"
                }   ${hamShow ? "keyzi_navLink--list-show" : ""}`}
              >
                <ul>
                  <li>
                    <Link to={Routers.Home}>Driving Lessons</Link>
                  </li>
                  <li>
                    <Link to={Routers.Home}>Test Packages</Link>
                  </li>
                  <li>
                    <Link to={Routers.Home}>Gift Vouchers </Link>
                  </li>
                  <li>
                    <Link to={Routers.Home}>Pricing</Link>
                  </li>
                  <li className="hide2-class">
                    {loggedIn || token ? (
                      <div className="login_user_section d-flex align-items-center d-lg-flex">
                        <div className="profile_wrapper">
                          <img
                            src={
                              userImage
                                ? `https://keyzi.com.au/keyzi-admin/public${userImage}`
                                : defaultUserPic
                            }
                            alt="login_user_pic"
                            className="login_user_profile"
                          />
                        </div>
                        <span className="d-none">{update}</span>
                        <Dropdown
                          align="end"
                          show={showDropdown}
                          onToggle={toggleDropdown}
                        >
                          <Dropdown.Toggle
                            className={`login_dropdown ${
                              !loggedIn && "home_color_text"
                            }`}
                            variant="success"
                            id="dropdown-basic"
                            onClick={toggleDropdown}
                          >
                            {userName}
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Link
                              className="drop_popup"
                              to={Routers.Dashboard}
                              onClick={toggleDropdown} // Close the dropdown when clicking on "My Account"
                            >
                              Dashboard
                            </Link>
                            <Dropdown.Divider />
                            <Link
                              className="drop_popup"
                              to={Routers.Profile}
                              onClick={toggleDropdown} // Close the dropdown when clicking on "My Account"
                            >
                              My Profile
                            </Link>
                            <Dropdown.Divider />
                            <Link
                              onClick={logoutHandler}
                              to={Routers.Login}
                              className="drop_popup"
                            >
                              Log Out
                            </Link>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    ) : (
                      <Button
                        className="loginheader_btn d-lg-block br-10"
                        onClick={() => {
                          navigate(Routers.Login);
                        }}
                      >
                        Login
                      </Button>
                    )}
                  </li>
                </ul>
              </div>
              <div
                className={`keyzi_navLink--list  ${
                  hamShow ? "keyzi_navLink--list-show hide-class" : ""
                }`}
              >
                <ul>
                  <li>
                    {loggedIn || token ? (
                      <div className="login_user_section d-flex align-items-center d-lg-flex">
                        <div className="profile_wrapper">
                          <img
                            src={
                              userImage
                                ? `https://keyzi.com.au/keyzi-admin/public${userImage}`
                                : defaultUserPic
                            }
                            alt="login_user_pic"
                            className="login_user_profile"
                          />
                        </div>
                        <span className="d-none">{update}</span>
                        <Dropdown
                          align="end"
                          show={showDropdown}
                          onToggle={toggleDropdown}
                        >
                          <Dropdown.Toggle
                            className={`login_dropdown ${
                              !loggedIn && "home_color_text"
                            }`}
                            variant="success"
                            id="dropdown-basic"
                            onClick={toggleDropdown}
                          >
                            {userName}
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Link
                              className="drop_popup"
                              to={Routers.Dashboard}
                              onClick={toggleDropdown} // Close the dropdown when clicking on "My Account"
                            >
                              Dashboard
                            </Link>
                            <Dropdown.Divider />
                            <Link
                              className="drop_popup"
                              to={Routers.Profile}
                              onClick={toggleDropdown} // Close the dropdown when clicking on "My Account"
                            >
                              My Profile
                            </Link>
                            <Dropdown.Divider />
                            <Link
                              onClick={logoutHandler}
                              to={Routers.Login}
                              className="drop_popup"
                            >
                              Log Out
                            </Link>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    ) : (
                      <Button
                        className="loginheader_btn d-lg-block br-10"
                        onClick={() => {
                          navigate(Routers.Login);
                        }}
                      >
                        Login
                      </Button>
                    )}
                  </li>
                </ul>
              </div>

              <div
                className="hamburger hamburger_white"
                onClick={() => {
                  setHamShow(!hamShow);
                }}
              >
                <div className="hb-line"></div>
                <div className="hb-line"></div>
                <div className="hb-line"></div>
              </div>
            </div>
          </Container>
        </nav>
      ) : (
        <nav className={`keyzi_navbar--wrapper ${stickyClass}`}>
          <Container>
            <div className="keyzi_navbar--inner">
              <div className="keyzi_logo--link">
                <h1>
                  <Link to={Routers.Home}>keyzi</Link>
                </h1>
              </div>
              {containsCorporateSiteone && (
                <div
                  className={`${
                    containsCorporateSiteone
                      ? "keyzi_navList--listCsTwo"
                      : "keyzi_navLink--list"
                  }   ${hamShow ? "keyzi_navLink--list-show" : ""}`}
                >
                  <ul>
                    <li>
                      <Link to={Routers.Home}>Home</Link>
                    </li>
                    <li>
                      <Link to={Routers.guide}>Local Instructors</Link>
                    </li>
                    <li>
                      <Link to={Routers.embark}>Book A Lesson</Link>
                    </li>
                    <li>
                      <Link to={Routers.Home}>Refer A Friend</Link>
                    </li>
                    <li>
                      <HashLink smooth to="#testimonial_section">
                        Testimonials
                      </HashLink>
                    </li>
                    <li>
                      {loggedIn || token ? (
                        <div className="login_user_section d-flex align-items-center d-lg-flex">
                          <div className="profile_wrapper">
                            <img
                              src={
                                userImage
                                  ? `https://keyzi.com.au/keyzi-admin/public${userImage}`
                                  : defaultUserPic
                              }
                              alt="login_user_pic"
                              className="login_user_profile"
                            />
                          </div>
                          <span className="d-none">{update}</span>
                          <Dropdown
                            align="end"
                            show={showDropdown}
                            onToggle={toggleDropdown}
                          >
                            <Dropdown.Toggle
                              className={`login_dropdown ${
                                !loggedIn && "home_color_text"
                              }`}
                              variant="success"
                              id="dropdown-basic"
                              onClick={toggleDropdown}
                            >
                              {userName}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Link
                                className="drop_popup"
                                to={Routers.Dashboard}
                                onClick={toggleDropdown} // Close the dropdown when clicking on "My Account"
                              >
                                Dashboard
                              </Link>
                              <Dropdown.Divider />
                              <Link
                                className="drop_popup"
                                to={Routers.Profile}
                                onClick={toggleDropdown} // Close the dropdown when clicking on "My Account"
                              >
                                My Profile
                              </Link>
                              <Dropdown.Divider />
                              <Link
                                onClick={logoutHandler}
                                to={Routers.Login}
                                className="drop_popup"
                              >
                                Log Out
                              </Link>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      ) : (
                        <Button
                          className="loginheader_btn  br-10"
                          onClick={() => {
                            navigate(Routers.Login);
                          }}
                        >
                          Login
                        </Button>
                      )}
                    </li>
                  </ul>
                </div>
              )}
              {containsCorporateSiteone ? (
                <div className="keyzi_navLink--list">
                  <ul>
                    <li>
                      {loggedIn || token ? (
                        <div className="login_user_section d-flex align-items-center d-lg-flex">
                          <div className="profile_wrapper">
                            <img
                              src={
                                userImage
                                  ? `https://keyzi.com.au/keyzi-admin/public${userImage}`
                                  : defaultUserPic
                              }
                              alt="login_user_pic"
                              className="login_user_profile"
                            />
                          </div>
                          <span className="d-none">{update}</span>
                          <Dropdown
                            align="end"
                            show={showDropdown}
                            onToggle={toggleDropdown}
                          >
                            <Dropdown.Toggle
                              className={`login_dropdown ${
                                !loggedIn && "home_color_text"
                              }`}
                              variant="success"
                              id="dropdown-basic"
                              onClick={toggleDropdown}
                            >
                              {userName}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Link
                                className="drop_popup"
                                to={Routers.Dashboard}
                                onClick={toggleDropdown} // Close the dropdown when clicking on "My Account"
                              >
                                Dashboard
                              </Link>
                              <Dropdown.Divider />
                              <Link
                                className="drop_popup"
                                to={Routers.Profile}
                                onClick={toggleDropdown} // Close the dropdown when clicking on "My Account"
                              >
                                My Profile
                              </Link>
                              <Dropdown.Divider />
                              <Link
                                onClick={logoutHandler}
                                to={Routers.Login}
                                className="drop_popup"
                              >
                                Log Out
                              </Link>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      ) : (
                        <Button
                          className="loginheader_btn d-lg-block br-10"
                          onClick={() => {
                            navigate(Routers.Login);
                          }}
                        >
                          Login
                        </Button>
                      )}
                    </li>
                  </ul>
                </div>
              ) : (
                <div
                  className={`keyzi_navLink--list ${
                    hamShow ? "keyzi_navLink--list-show" : ""
                  }`}
                >
                  <ul>
                    {dynamicRoutes?.length > 0 ? (
                      <>
                        {uniqueHomeRoutes.map((e) => (
                          <li key={e.slug} className="d-none">
                            <Link to={e.path}>{e.pagename}</Link>
                          </li>
                        ))}
                      </>
                    ) : (
                      <>
                        <li className="d-none">
                          <Link to={Routers.Home}>Home</Link>
                        </li>
                        <li className="d-none">
                          <Link to={Routers.drivinglessonsnew}>
                            Driving Lessons
                          </Link>
                        </li>
                        <li className="d-none">
                          <Link to={Routers.testPackagesnew}>
                            Tests & Packages
                          </Link>
                        </li>
                        <li className="d-none">
                          <Link to={Routers.giftvoucher}>Gift Vouchers</Link>
                        </li>
                        <li className="d-none">
                          <HashLink smooth to="xcsfvt/#testimonial_section">
                            Testimonials
                          </HashLink>
                        </li>
                      </>
                    )}

                    <li>
                      {loggedIn || token ? (
                        <div className="login_user_section d-flex align-items-center d-lg-flex">
                          <div className="profile_wrapper">
                            <img
                              src={
                                userImage
                                  ? `https://keyzi.com.au/keyzi-admin/public${userImage}`
                                  : defaultUserPic
                              }
                              alt="login_user_pic"
                              className="login_user_profile"
                            />
                          </div>
                          <span className="d-none">{update}</span>
                          <Dropdown
                            align="end"
                            show={showDropdown}
                            onToggle={toggleDropdown}
                          >
                            <Dropdown.Toggle
                              className={`login_dropdown ${
                                !loggedIn && "home_color_text"
                              }`}
                              variant="success"
                              id="dropdown-basic"
                              onClick={toggleDropdown}
                            >
                              {userName}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Link
                                className="drop_popup"
                                to={Routers.Dashboard}
                                onClick={toggleDropdown} // Close the dropdown when clicking on "My Account"
                              >
                                Dashboard
                              </Link>
                              <Dropdown.Divider />
                              <Link
                                className="drop_popup"
                                to={Routers.Profile}
                                onClick={toggleDropdown} // Close the dropdown when clicking on "My Account"
                              >
                                My Profile
                              </Link>
                              <Dropdown.Divider />
                              <Link
                                onClick={logoutHandler}
                                to={Routers.Login}
                                className="drop_popup"
                              >
                                Log Out
                              </Link>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      ) : (
                        <Button
                          className="loginheader_btn d-lg-block br-10"
                          onClick={() => {
                            navigate(Routers.Login);
                          }}
                        >
                          Login
                        </Button>
                      )}
                    </li>
                  </ul>
                </div>
              )}
              <div
                className="hamburger"
                onClick={() => {
                  setHamShow(!hamShow);
                }}
              >
                <div className="hb-line"></div>
                <div className="hb-line"></div>
                <div className="hb-line"></div>
              </div>
            </div>
          </Container>
        </nav>
      )}
    </header>
  );
};
